import type { Card } from '../../types';

/** Starter defense (ADR-0015 §5, §15, §19). Rare 2×1, low-die cost. Cost-face
 * bonus restores meaning to the rolled face within the `≤3` window: 4 block on a
 * 2 or 3, 10 block on a 1 (the luck band). */
export const BRACE: Card = {
  id: 'brace',
  name: 'Brace',
  type: 'defense',
  rarity: 'rare',
  size: { w: 2, h: 1 },
  cost: [{ kind: 'max', value: 3 }],
  effects: [{ kind: 'block', amount: 4 }],
  costBonuses: [
    { facePredicate: { kind: 'exact', value: 1 }, effects: [{ kind: 'block', amount: 6 }] },
  ],
};
